import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import OfficialMediaModalStore from '@src/business-components/official-media-modal/store';
import useModal from '@src/utils/hooks/use-modal';
import OfficialMediaModal from '@src/business-components/official-media-modal';

class OfficialCommunityStore {
  officialMedialModalStore = new OfficialMediaModalStore();

  /**
   * top - 顶栏
   * main - 首页
   * other - 其他页面
   */
  @observable type;

  @observable isHideTopMenu;

  onOfficialModalOpen = type => {
    this.officialMedialModalStore.communityType = type;
    this.officialMedialModalStore.isOpen = true;
    this.officialMedialModal.open();
  };
  constructor(options = {}) {
    Object.assign(this, options);
  }

  use() {
    useMount(async () => {
      console.log('componentDidMount');
    });

    this.officialMedialModal = useModal(OfficialMediaModal, { store: this.officialMedialModalStore });
  }
}

export default OfficialCommunityStore;
